import { Linkedin } from "lucide-react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import { TEAM } from "../../data/content";
import { TEAM_PHOTOS } from "../../data/teamPhotos";
import "./TeamPage.css";

export default function TeamPage() {
  return (
    <div className="team-page">
      <PageHero
        badge="Our Team"
        title="CFA, CA & CS-led expertise"
        subtitle="Meet the professionals guiding portfolios, business finance, tax, and compliance for India's investors and founders."
        actions={[
          { label: "Book Free Consultation", to: "/contact", primary: true },
          { label: "Our Services", to: "/services" },
        ]}
      />

      <section className="pm-section team-section">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            Leadership & Advisors
          </span>
          <h2 className="pm-section-title">People behind Poonji Mitra</h2>
          <p className="pm-section-sub">
            Deep credentials. Practical advice. Long-term partnerships.
          </p>

          <div className="team-grid">
            {TEAM.map((member) => {
              const photo = TEAM_PHOTOS[member.id];
              return (
                <article key={member.id} className="pm-card team-card">
                  <div className="team-card__media">
                    {photo ? (
                      <img src={photo} alt={member.name} loading="lazy" />
                    ) : (
                      <div className="team-card__initials" aria-hidden>
                        {member.initials}
                      </div>
                    )}
                  </div>
                  <div className="team-card__body">
                    <h3>{member.name}</h3>
                    <span className="team-card__role">{member.designation}</span>
                    <span className="team-card__qual">{member.qualification}</span>
                    <p>{member.expertise}</p>
                    {member.linkedin && (
                      <a
                        href={member.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="team-card__linkedin"
                        aria-label={`${member.name} on LinkedIn`}
                      >
                        <Linkedin size={18} />
                        LinkedIn
                      </a>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <CtaBand
        title="Want advice from our team?"
        subtitle="Book a free consultation and speak with the right expert for your goals."
        primary={{ label: "Book Free Consultation", to: "/contact" }}
        secondary={{ label: "Talk to an Expert", to: "/contact" }}
      />
    </div>
  );
}
